export const formatDayOfWeek = (dayOfWeek: string | null): string | null => {
  if (dayOfWeek === null) {
    return null;
  }

  return `${dayOfWeek.slice(0, 1).toUpperCase()}${dayOfWeek.slice(1, 3)}`;
};
